/*
 * @Author: wblijinyang
 * @FilePath: /code/mall-fe/src/views/web/product/context/TradeMode.tsx
 * @Description:
 */
import { createContext, useContext, useState, useEffect, useMemo } from 'react';
import { useTradeAgreementContext } from 'views/web/product/context';

const TradeModeContext = createContext(null);

const TradeModeContextProvider = ({ children }) => {
  const { selectTradeAgreement } = useTradeAgreementContext();
  let activeDiscount = null;
  if (selectTradeAgreement?.discountByMethodList?.length) {
    activeDiscount =
      selectTradeAgreement.discountByMethodList.find(({ active }) => active) ||
      selectTradeAgreement.discountByMethodList[0];

    if (activeDiscount) {
      activeDiscount.sysNo =
        activeDiscount.accountPeriod +
        '-' +
        (activeDiscount.billingPeriod == null ? '' : activeDiscount.billingPeriod);
    }
  }

  const [selectTradeMode, setSelectTradeMode] = useState(activeDiscount || {});
  useEffect(() => {
    setSelectTradeMode(activeDiscount || {});
  }, [activeDiscount, setSelectTradeMode]);
  const tradeModeData = useMemo(
    () => ({ selectTradeMode, setSelectTradeMode }),
    [selectTradeMode, setSelectTradeMode],
  );
  return <TradeModeContext.Provider value={tradeModeData}>{children}</TradeModeContext.Provider>;
};

const useTradeModeContext = () => {
  const context = useContext(TradeModeContext);
  if (context === undefined) {
    throw new Error('useTradeModeContext must be used within a TradeModeContextProvider');
  }
  return context;
};

export { TradeModeContextProvider, useTradeModeContext };
